module.exports = __webpack_public_path__ + "static/img/No_image_available.4536ea98.svg";